export const storePages = {
  iban: {
    queryName: "iban",
    ios: "fd4e3a43-6de5-42a0-a523-5c9f350b013c",
    android: "iban-oplata",
  },
  prro: {
    queryName: "prro",
    ios: "43062420-7849-402b-b03d-b2a9736d864b",
    android: "homepage",
  },
  obratyPrro: {
    queryName: "obratyPrro",
    ios: "5100c4f5-e3c6-4a2a-903d-619ab250a50a",
    android: "obraty-prro",
  },
};
